import {
  DependencyMapReferenceParentViewModel,
  DependencyMapReferenceViewModel,
  DependencyMapReference,
  DependencyMapNodeViewModel,
  DependencyMapNode,
} from '../types';

type ConsolidateReferenceParentsReducerState = {
  rootParents: (
    | DependencyMapReferenceParentViewModel
    | DependencyMapReferenceViewModel
  )[];
  parentsByModelId: Map<string, DependencyMapReferenceParentViewModel>;
};

const consolidateReferenceParentsReducer = (
  state: ConsolidateReferenceParentsReducerState,
  current: DependencyMapReference
) => {
  const referenceViewModel = {
    ...current,
    node: {
      ...current.node,
      incomingReferences:
        current.node.incomingReferences?.reduce(
          consolidateReferenceParentsReducer,
          { rootParents: [], parentsByModelId: new Map() }
        ).rootParents ?? null,
      outgoingReferences:
        current.node.outgoingReferences?.reduce(
          consolidateReferenceParentsReducer,
          { rootParents: [], parentsByModelId: new Map() }
        ).rootParents ?? null,
      combinedReferences:
        current.node.combinedReferences?.reduce(
          consolidateReferenceParentsReducer,
          { rootParents: [], parentsByModelId: new Map() }
        ).rootParents ?? null,
    },
  };
  let parent = referenceViewModel.parent;
  let root:
    | DependencyMapReferenceViewModel
    | DependencyMapReferenceParentViewModel = referenceViewModel;
  while (parent) {
    const parentViewModel = state.parentsByModelId.get(parent.modelId);
    if (parentViewModel) {
      parentViewModel.children?.push(root);
      return state;
    }
    root = { ...parent, children: [root] };
    state.parentsByModelId.set(root.modelId, root);
    parent = parent.parent;
  }
  state.rootParents.push(root);
  return state;
};

const consolidateNodeReferenceParentsReducer = (
  result: DependencyMapNodeViewModel[],
  current: DependencyMapNode
): DependencyMapNodeViewModel[] => {
  result.push({
    ...current,
    children:
      current.children?.reduce(consolidateNodeReferenceParentsReducer, []) ??
      null,
    incomingReferences:
      current.incomingReferences?.reduce(consolidateReferenceParentsReducer, {
        rootParents: [],
        parentsByModelId: new Map(),
      }).rootParents ?? null,
    outgoingReferences:
      current.outgoingReferences?.reduce(consolidateReferenceParentsReducer, {
        rootParents: [],
        parentsByModelId: new Map(),
      }).rootParents ?? null,
    combinedReferences:
      current.combinedReferences?.reduce(consolidateReferenceParentsReducer, {
        rootParents: [],
        parentsByModelId: new Map(),
      }).rootParents ?? null,
  });
  return result;
};
export { consolidateNodeReferenceParentsReducer };
